export enum DiscountStatusCode {
  Aktīva = 'AAKT',
  Aizstāta = 'AAIZ',
  Noraidīta = 'ANOR',
  Piedāvāta = 'APIE',
}
